import { useMediaQuery } from "react-responsive";

export const MEDIAS = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
    const isTablet = useMediaQuery({ query: "(max-width: 1024px)" });
    const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
    const isDesktop = useMediaQuery({ query: "(max-width: 1920px)" });

    return { isMobile, isTablet, isLaptop, isDesktop };
};
